import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { Form, Input, Button, Card, Row, Col, Select, Upload, message, Typography, Switch, InputNumber, Table } from "antd";
import { EyeOutlined, PlusOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import '../../scss/supplierStyle.scss';
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import SupplierService from "../../utils/api/supplierdirectory";
import { max, min } from "moment";

function CreateSupplierForm({ supplierId, onSuccess, disabledFields = [], onLoadingChange = () => {} }) {

  const { Title, Text } = Typography;
  const [loadingCountries, setLoadingCountries] = useState(true);


  const getUserId = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        return user.id || '1';
      } catch (err) {
        console.error('Error parsing user from localStorage:', err);
        return '1';
      }
    }
    return '1';
  };



  const uploadFileToFirebase = async (file) => {
    const storage = getStorage();

    const fileRef = ref(
      storage,
      `suppliers/catalogs/${Date.now()}_${file.name}`
    );

    await uploadBytes(fileRef, file);
    const url = await getDownloadURL(fileRef);

    return url;
  };
  const currentUserId = getUserId();

  const [countries, setCountries] = useState([]);
  const [form] = Form.useForm();
  const [selectedCountry, setSelectedCountry] = useState('MX');
  const [loadingStates, setLoadingStates] = useState(false);
  const [states, setStates] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [cities, setCities] = useState([]);
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const { Option } = Select;
  const [st, setSt] = useState({
    logo: null
  })
  const [loading, setLoading] = useState(false);
  const submitLockRef = useRef(false);
  const [value, setValue] = useState();

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {

      if (!(file instanceof Blob)) {
        resolve(null);
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;

    });

  const fetchCountries = useCallback(async () => {
    setLoadingCountries(true);
    try {
      const response = await fetch('https://countriesnow.space/api/v0.1/countries');
      const data = await response.json();

      if (data.error) {
        throw new Error(data.msg || 'Error al cargar países');
      }

      const formattedCountries = data.data.map(country => ({
        name: country.country,
        code: country.iso2 || country.iso3 || country.country.substring(0, 2).toUpperCase()
      })).sort((a, b) => {
        if (a.code === 'MX') return -1;
        if (b.code === 'MX') return 1;
        return a.name.localeCompare(b.name);
      });

      setCountries(formattedCountries);
    } catch (error) {
      console.error('Error fetching countries:', error);
      message.error('Error al cargar la lista de países. Intenta recargar la página.');

      const backupCountries = [
        { code: 'MX', name: 'México' },
        { code: 'US', name: 'Estados Unidos' },
        { code: 'CA', name: 'Canadá' },
        { code: 'ES', name: 'España' },
      ];
      setCountries(backupCountries);
    } finally {
      setLoadingCountries(false);
    }
  }, []);

  const handleStateChange = useCallback(async (stateName) => {
    const countryName = countries.find(c => c.code === selectedCountry)?.name;
    if (!countryName || !stateName) return;

    form.setFieldsValue({ city: undefined });
    setCities([]);

    setLoadingCities(true);
    try {
      const response = await fetch('https://countriesnow.space/api/v0.1/countries/state/cities', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          country: countryName,
          state: stateName
        })
      });

      const data = await response.json();

      if (data.data && Array.isArray(data.data)) {
        const citiesList = data.data.map((city, index) => ({
          name: city,
          id: city || index
        }));
        setCities(citiesList);

        if (selectedCountry === 'MX' && stateName.toLowerCase().includes('chihuahua')) {
          const juarez = citiesList.find((city) => {
            const cityName = city.name.toLowerCase().trim();
            return (
              cityName === 'juárez'           
            );
          });

          if (juarez) {
            form.setFieldsValue({
              city: juarez.name,
              postal_code: '32000'
            });
          } else {
            form.setFieldsValue({
              city: 'Juárez',
              postal_code: '32000'
            });
          }
        }
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
      message.warning('No se pudieron cargar las ciudades.');
    } finally {
      setLoadingCities(false);
    }
  }, [countries, selectedCountry, form]);

  const handleCountryChange = useCallback(async (countryName) => {
    const selected = countries.find(c => c.name === countryName);
    if (!selected) return;

    setSelectedCountry(selected.code);
    form.setFieldsValue({
      state: undefined,
      city: undefined,
      postal_code: undefined
    });
    setStates([]);
    setCities([]);

    setLoadingStates(true);
    try {
      const response = await fetch('https://countriesnow.space/api/v0.1/countries/states', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ country: countryName })
      });

      const data = await response.json();

      if (data.data?.states && Array.isArray(data.data.states)) {
        const statesList = data.data.states.map((state, index) => ({
          name: state.name,
          id: state.id || state.name || index
        }));
        setStates(statesList);

        if (selected.code === 'MX' && statesList.length > 0) {
          const chihuahua = statesList.find(state =>
            state.name.toLowerCase().includes('chihuahua')
          );

          if (chihuahua) {
            form.setFieldsValue({ state: chihuahua.name });
            handleStateChange(chihuahua.name);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching states:', error);
      message.warning('No se pudieron cargar los estados.');
    } finally {
      setLoadingStates(false);
    }
  }, [countries, form, handleStateChange]);

  useEffect(() => {

    form.resetFields();
  }, [supplierId, form]);

  const loadSupplier = async () => {
    try {
      const data1 = await SupplierService.GetSupplierById(supplierId);
      const data = data1.data;
      console.log("Supplier data loaded:", data);
      form.setFieldsValue({
        bussiness: data.bussiness,
        description: data.description,
        category: data.category,
        subcategory: data.subcategory,
        country: data.country,
        state: data.state,
        city: data.city,
        street: data.street,
        postal_code: data.postal_code,
        website: data.website,
        rfc: data.rfc,
        iva: data.iva,
        porcentage_iva: data.porcentage_iva,
        credit_days: data.credit_days,
        contacts: data.contacts || []
      });

      if (data.logo) {
        form.setFieldsValue({
          logo: [
            {
              uid: "-1",
              name: "logo.png",
              status: "done",
              url: data.logo
            }
          ]
        });
      }


      if (data.certificates && data.certificates.length > 0) {

        const certFiles = data.certificates.map((cert) => ({
          uid: cert.id,
          name: cert.fileName,
          status: "done",
          url: cert.fileUrl
        }));

        form.setFieldsValue({
          certificates: certFiles
        });

      }

      if (data.catalog && data.catalog.length > 0) {

        const catalog = data.catalog.map((cert) => ({
          uid: cert.id,
          name: cert.fileName,
          status: "done",
          url: cert.fileUrl
        }));

        form.setFieldsValue({
          catalog: catalog
        });

      }

    } catch (error) {
      console.error("Error loading supplier", error);
    }

  };


  useEffect(() => {
    fetchCountries();
  }, [fetchCountries]);

  useEffect(() => {
    if (countries.length > 0 && selectedCountry === 'MX' && !initialLoadDone) {
      const mexico = countries.find(c => c.code === 'MX');
      if (mexico && !form.getFieldValue('state')) {
        form.setFieldsValue({ country: mexico.name });
        handleCountryChange(mexico.name);
        setInitialLoadDone(true);
      }

    }
  }, [countries, form, selectedCountry, handleCountryChange, initialLoadDone]);

  useEffect(() => {

    if (!supplierId) return;

    loadSupplier();

  }, [supplierId]);




  const onFinish = async (values) => {
    if (submitLockRef.current) {
      return;
    }

    submitLockRef.current = true;
    setLoading(true);
    onLoadingChange(true);

    try {
      let logoBase64 = "";

      if (values.logo && values.logo.length > 0) {
        logoBase64 = values.logo[0].thumbUrl;
      }
      let catalogBase64 = [];


      if (values.catalog?.length > 0) {

        catalogBase64 = await Promise.all(
          values.catalog.map(async (file) => {

            if (file.originFileObj instanceof Blob) {
              const url = await uploadFileToFirebase(file.originFileObj);

              return {
                fileName: file.name,
                fileUrl: url
              };
            }

            if (file.url) {
              return {
                fileName: file.name,
                fileUrl: file.url
              };
            }
            return null;
          })
        );

        catalogBase64 = catalogBase64.filter(Boolean);
      }

      let certificatesArray = [];

      if (values.certificates?.length > 0) {

        certificatesArray = await Promise.all(
          values.certificates.map(async (file) => {

            if (file.originFileObj instanceof Blob) {
              return {
                fileName: file.name,
                fileBase64: await toBase64(file.originFileObj)
              };
            }

            if (file.url) {
              return {
                fileName: file.name,
                fileUrl: file.url
              };
            }
            return null;
          })
        );

        certificatesArray = certificatesArray.filter(Boolean);
      }

      const parsedIva = values.porcentage_iva != null && values.porcentage_iva !== '' ? parseFloat(values.porcentage_iva) : 0;
      const parsedCreditDays = values.credit_days != null && values.credit_days !== '' ? Number(values.credit_days) : 0;
      const normalizedWebsite = values.website?.trim() ? values.website.trim() : null;

      const supplier = {
        bussiness: values.bussiness,
        description: values.description,
        category: values.category,
        subcategory: values.subcategory,
        country: values.country,
        state: values.state,
        city: values.city,
        street: values.street,
        website: normalizedWebsite,
        rfc: values.rfc || '',
        porcentage_iva: parsedIva,
        iva: parsedIva,
        credit_days: parsedCreditDays,
        creditDays: parsedCreditDays,
        createdBy: currentUserId,
        updatedBy: currentUserId,
        logo: logoBase64,
        catalogBase64: catalogBase64 || [],
        contacts: values.contacts || [],
        certificates: certificatesArray || []
      };
      console.log("Supplier data to submit:", supplier);

      if (supplierId) {

        await SupplierService.EditSupplier(supplierId, supplier);
        message.success("Proveedor actualizado");
      } else {

        const response = await SupplierService.AddSupplier(supplier);

        form.resetFields();
        message.success("Proveedor creado");
      }
      onSuccess();

    } catch (error) {
      console.error(error);

      message.error("Error al crear proveedor");
    } finally {
      submitLockRef.current = false;
      setLoading(false);
      onLoadingChange(false);

    }
  };

  const isDisabled = (field) => disabledFields && disabledFields.includes(field);



  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinish}
      initialValues={{
        contacts: [{}]
      }}
    >

      <div className="form-container">
        <Row gutter={24} >
          <Col style={{ marginBottom: 16 }}>
            <Title level={5} style={{ color: "#1E3A8A", fontWeight: 700 }}>
              INFORMACIÓN GENERAL</Title>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Item label="Nombre de la empresa" name="bussiness"
              rules={[{ required: true, message: 'Ingresa el nombre de la empresa', min: 3, message: 'Mínimo 3 caracteres', max: 150, message: 'Máximo 150 caracteres' }]}
            >
              <Input placeholder="Ej: EP&O" maxLength={150} disabled={isDisabled('bussiness')} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Descripción Empresa" name="description"
              rules={[{ required: true, message: 'Ingresa la descripción de la empresa', min: 3, message: 'Mínimo 3 caracteres', max: 200, message: 'Máximo 200 caracteres' }]}>
              <Input maxLength={200} disabled={isDisabled('description')} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="country"
              label="País"
              rules={[{ required: true, message: 'Selecciona un país' }]}
            >
              <Select
                placeholder="Selecciona tu país"
                loading={loadingCountries}
                onChange={handleCountryChange}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                value={form.getFieldValue('country') || (countries.find(c => c.code === 'MX')?.name)}
                disabled={isDisabled('country')}
              >
                {countries.map(country => (
                  <Option key={country.code} value={country.name}>
                    {country.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="state"
              label="Estado/Provincia"
              rules={[{ required: true, message: 'Selecciona un estado' }]}
            >
              <Select
                placeholder="Selecciona estado"
                loading={loadingStates}
                onChange={handleStateChange}
                disabled={isDisabled('state') || !selectedCountry}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }

              >
                {states.map(state => (
                  <Option key={state.id} value={state.name}>
                    {state.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="city"
              label="Ciudad"
              rules={[{ required: true, message: 'Selecciona una ciudad' }]}
            >
              <Select
                placeholder="Selecciona ciudad"
                loading={loadingCities}

                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                disabled={isDisabled('city')}
              >
                {cities.map(city => (
                  <Option key={city.id} value={city.name}>
                    {city.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>

            <Form.Item
              name="street"
              label="Calle"
              rules={[
                { required: true, message: 'Ingresa la calle' },
                { min: 3, message: 'Mínimo 3 caracteres' },
                { max: 100, message: 'Máximo 100 caracteres' }
              ]}
            >
              <Input placeholder="Ej: Av. Principal 123" maxLength={100} disabled={isDisabled('street')} />
            </Form.Item>

          </Col>
          <Col span={12}>
            <Form.Item label="Categoria" name="category" rules={[{ required: true, message: 'Selecciona una categoría' }]}>
              <Select placeholder="Seleccionar categoria" disabled={isDisabled('category')}>

                <Option value={1}>MRO</Option>
                <Option value={3}>MRP</Option>
                <Option value={4}>Servicios</Option>
                <Option value={2}>Empaque</Option>
                <Option value={6}>Tecnología</Option>
                <Option value={5}>Maquinados</Option>

              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Subcategoria" name="subcategory"
              rules={[{ required: true, message: 'Pallets', min: 3, message: 'Mínimo 3 caracteres', max: 50, message: 'Máximo 50 caracteres' }]}>
              <Input maxLength={50} disabled={isDisabled('subcategory')} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} align="middle">


          <Col span={6}>

            <Form.Item
              label="% IVA"
              name="porcentage_iva"
            >
              <Select placeholder="Seleccionar IVA" disabled={isDisabled('porcentage_iva')}>

                <Option value={'0.08'}>8%</Option>
                <Option value={'0.16'}>16%</Option>

              </Select>
            </Form.Item>

          </Col>


          <Col span={6}>
            <Form.Item label="Dias de Credito" name="credit_days" rules={[{ type: 'number', max: 999, message: 'Máximo 3 dígitos' }]} >
              <InputNumber
                min={0}
                style={{ width: "100%" }}
                rules={[{ max: 999, message: 'Máximo 3 dígitos' }]}
                placeholder="Ej: 15"
                maxLength={3}
                disabled={isDisabled('credit_days')}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="RFC" name="rfc" rules={[
              {
                pattern: /^[A-Z0-9]+$/,
                message: "Solo se permiten letras mayúsculas y números",
              },
            ]}>
              <Input
                maxLength={13}
                onChange={(e) => {
                  e.target.value = e.target.value
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, "");
                }}
                placeholder="Ej: ABCD123456EFG"
                disabled={isDisabled('rfc')}
              />
            </Form.Item>
          </Col>

        </Row>
        <Row gutter={24} >

          <Col span={12}>
            <Form.Item label="Sitio Web" name="website" >

              <Input placeholder="Ej: https://www.ejemplo.com" disabled={isDisabled('website')} />
            </Form.Item>
          </Col>

          <Col span={12} style={{ marginBottom: 16 }}>
            <Form.Item
              label="Logo de la Empresa"
              name="logo"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) return e;
                return e?.fileList;
              }}
            >
              <Upload
                beforeUpload={() => false}
                maxCount={1}
                listType="picture"
                disabled={isDisabled('logo')}
              >
                <Button disabled={isDisabled('logo')}>Subir Logo</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} >

          <Col span={12}>

            <Form.Item
              label="Catalogo de la Empresa"
              name="catalog"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) return e;
                return e?.fileList;
              }}
            >
              <Upload
                beforeUpload={() => false}
                maxCount={5}
                listType="text"
                accept="application/pdf"
                onPreview={(file) => {
                  window.open(file.url);
                }}
                disabled={isDisabled('catalog')}
              >
                <Button disabled={isDisabled('catalog')}>Subir Catalogo</Button>
              </Upload>
            </Form.Item>
          </Col>

          <Col span={12} style={{ marginBottom: 16 }}>

            <Form.Item
              label="Certificados de la Empresa"
              name="certificates"

              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) return e;
                return e?.fileList;
              }}
            >
              <Upload
                beforeUpload={() => false}
                maxCount={5}

                listType="text"
                accept="application/pdf"
                onPreview={(file) => {
                  window.open(file.url);
                }}
                disabled={isDisabled('certificates')}
              >
                <Button disabled={isDisabled('certificates')}>Subir Certificados</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>

      </div>


      <Form.List name="contacts">
        {(fields, { add, remove }) => (
          <>
            <Row gutter={24} >
              <Col style={{ marginBottom: 16 }} span={12}>
                <Title level={5} style={{ color: "#1E3A8A", fontWeight: 700 }}>
                  CONTACTOS DE REFERENCIA</Title>
              </Col>
              <Col span={12} style={{ display: "flex", justifyContent: "flex-end", alignContent: "center" }}>
                <Button
                  type="primary"

                  icon={<PlusOutlined />}
                  onClick={() => add()}
                >
                  Añadir Contacto
                </Button>
              </Col>

            </Row>


            {fields.map(({ key, name }) => (
              <Card key={key} className="contact-card" >
                <Row gutter={24} justify="space-between" align="middle" >
                  <Col >

                    <Title level={5} style={{ color: "#1E3A8A", fontWeight: 600 }}>
                      Referencia  {name + 1}
                    </Title>
                  </Col>
                  {fields.length > 1 && (
                    <DeleteOutlined
                      className="delete-contact"
                      onClick={() => remove(name)}
                    />
                  )}

                </Row>


                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item name={[name, "name"]} label="Nombre" rules={[{ required: true, message: 'Ingresa el nombre del contacto', min: 3, message: 'Mínimo 3 caracteres', max: 100, message: 'Máximo 100 caracteres' }]}  >
                      <Input maxLength={100} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item name={[name, "position"]} label="Cargo" rules={[{ required: false, message: 'Ingresa el cargo del contacto', min: 3, message: 'Mínimo 3 caracteres', max: 35, message: 'Máximo 35 caracteres' }]}>
                      <Input maxLength={35} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item name={[name, "email"]} label="Correo" rules={[{ type: 'email', message: 'Ingresa un correo válido' }]}>
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item name={[name, "phone"]} label="Telefono"   >
                      <PhoneInput

                        country={"mx"}
                        enableSearch
                        inputStyle={{ width: "100%" }}
                        onChange={(value) => {
                          form.setFieldsValue({
                            phone: "+" + value

                          });
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item name={[name, "mobile"]} label="Celular" rules={[{ required: true, message: 'Ingresa el número de celular' }]}>
                      <PhoneInput
                        country={"mx"}
                        enableSearch
                        inputStyle={{ width: "100%" }}
                        onChange={(value) => {
                          form.setFieldsValue({
                            phone: "+" + value
                          });
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            ))}
          </>
        )}
      </Form.List>
      <Row gutter={24} style={{ marginTop: 16 }}>

        <Col span={24} style={{ display: "flex", justifyContent: "flex-end", alignContent: "center" }}>

          <Button
            style={{ color: "#FFFFFF", backgroundColor: "#1E3A8A" }}
            htmlType="submit"
            loading={loading}
            disabled={loading}
          >
            {loading ? "Guardando..." : "Guardar Proveedor"}
          </Button>
        </Col>
      </Row>


    </Form>
  );
}

export default CreateSupplierForm;
